import React from 'react';
import { styled } from 'styled-components';
import { Colors } from '../../../../../play-core/styles/Colors';
import { Device } from '../../../../../play-core/styles/Device';
import { IconWrapper } from '../../IconWrapper/IconWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
export const ActionIcon = ({
  isActive,
  icon,
  onClick,
  isHovering,
  withOuterPadding = true
}) => /*#__PURE__*/_jsx(StyledActionIcon, {
  isActive: isActive,
  onClick: onClick,
  isHovering: isHovering,
  withOuterPadding: withOuterPadding,
  children: /*#__PURE__*/_jsx(IconWrapper, {
    icon: icon,
    color: Colors.WHITE
  })
});
export const StyledActionIcon = styled.div.withConfig({
  displayName: "ActionIcon__StyledActionIcon",
  componentId: "sc-v8uh3k-0"
})(["align-self:end;transition:opacity 200ms ease-in-out,transform 200ms ease-in-out;opacity:", ";padding:", ";transform:scale(1);", "{&:hover{opacity:1;transform:scale(1.1);}}", "{opacity:0.7;}"], ({
  isActive,
  isHovering
}) => isActive || isHovering ? 0.7 : 0, ({
  withOuterPadding
}) => withOuterPadding ? '6px' : 0, Device.mouse, Device.touch);